module.exports = __webpack_public_path__ + "img/atlas_m.0af03f7c.jpg";